export default {
    ADD_INVESTOR(state, investors) {
        if (state.investors.length === 0) {
            state.investors.push(investors);
        } else {
            let index = state.investors.findIndex(
                element => element.id == investors.id
            );

            if (index === -1) {
                state.investors.push(investors);
            } else {
                state.investors[index] = investors;
            }
        }
    },

    REMOVE_INVESTOR(state, id) {
        let index = state.investors.findIndex(investor => investor.id == id);
        if (index !== -1) state.investors.splice(index, 1);
    },

    PUT_INVESTORS(state, investors) {
        state.investors = investors;
    }
};
